import React from 'react';
import { getCountryCode } from '@cyberint/common-utils';
import { Flag } from '@cyberint/dsc';
import { t } from '@cyberint/stateful-ui/i18n';
import {
  DateCell,
  SimpleCell
} from '@cyberint/stateful-ui/victimology/VictimologyTable/components/RecentAttacksTable/components/Cells';
import { COUNTRY, ORGANIZATION, SECTOR } from '@cyberint/stateful-ui/victimology/VictimologyTable/utils';
import * as S from '../../styled';

export const getColumns = columnClickHandler => {
  const onColumnClick = (value, field) => () => columnClickHandler(value, field);

  return [
    {
      header: t('victimology.table.header.company'),
      accessorKey: ORGANIZATION,
      disableSortBy: true,
      size: 200,
      Cell: ({ renderedCellValue: value }) => <SimpleCell value={value} onClick={onColumnClick(value, ORGANIZATION)} />
    },
    {
      header: t('victimology.table.header.sector'),
      accessorKey: SECTOR,
      disableSortBy: true,
      size: 120,

      Cell: ({ renderedCellValue: value }) => <SimpleCell value={value} onClick={onColumnClick(value, SECTOR)} />
    },
    {
      header: t('victimology.table.header.country'),
      accessorKey: COUNTRY,
      disableSortBy: true,
      size: 150,
      Cell: ({ renderedCellValue: value }) => {
        const countryCode = getCountryCode(value);
        return (
          <S.HorValues onClick={onColumnClick(value, COUNTRY)}>
            {countryCode && <Flag alt={value} code={countryCode} size={22} />}
            <SimpleCell value={value} />
          </S.HorValues>
        );
      }
    },
    {
      header: t('victimology.table.header.attack_date'),
      accessorKey: 'date',
      disableSortBy: true,
      size: 120,
      Cell: DateCell
    }
  ];
};
